import type { TableView } from 'owa-mail-list-store';
import { mutatorAction } from 'satcheljs';

const tableExitVirtualSelectAllModeMutator: (tableView: TableView) => void = mutatorAction(
    'tableExitVirtualSelectAllMode',
    function tableExitVirtualSelectAllMode(tableView: TableView): void {
        tableView.isInVirtualSelectAllMode = false;
        // Skip resetting already-empty observable arrays to avoid triggering unnecessary MobX reactions
        if (
            !tableView.virtualSelectAllExclusionList ||
            tableView.virtualSelectAllExclusionList.length > 0
        ) {
            tableView.virtualSelectAllExclusionList = [];
        }
        tableView.selectAllModeTimeStamp = null;
    }
);
export default tableExitVirtualSelectAllModeMutator;
